export const environment = {
    state: "test",
    production: false,
    showTesting: true,
    apiUrl: "https://baer-nonprd-app-be-stg.azurewebsites.us/baer/api",
    authUrl: "https://fsappsgateway-stg.fs2c.usda.gov/oauth2",
    clientId: "BAERBARSTG",
    redirectUrl: "https://baer-stg.fs2c.usda.gov/login-redirect"
}
